import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { IonSlides, NavController } from '@ionic/angular';
import { ParamServicesService } from 'src/app/services/param-services.service';
import { SlideService } from 'src/app/services/slide.service';
import { UiServices } from 'src/app/services/ui-services';
import { OpenCarruselGalleriesComponent } from './components/open-carrusel-galleries/open-carrusel-galleries.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-slider-galeries',
  templateUrl: './slider-galeries.component.html',
  styleUrls: ['./slider-galeries.component.scss'],
})
export class SliderGaleriesComponent implements OnInit, AfterViewInit {
  @ViewChild('slideGallery') slideGallery: IonSlides;
  @Input() galleries: any[] = [];
  @Input() data: any = undefined;
  @Input() categoryId: any = undefined;
  @Input() catalogueId: any = undefined;
  @Output() emitGalleyId = new EventEmitter();

  public reachedEnd = false;
  public isStart = true;
  public slidesOpts: any = {
    breakpoints: {
      220: {
        slidesPerView: 1.1,
      },
      520: {
        slidesPerView: 2.1,
      },
      700: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  };

  constructor(
    private uiSv: UiServices,
    private navCtrl: NavController,
    private slideSv: SlideService,
    private _paramSv: ParamServicesService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }
    this.slideSv.comprobeCenter(this.data, this.slidesOpts);
  }

  goGallery(gallery) {
    const galleryStyle = this._paramSv.styles.find(
      (x) => x.text === 'Slider de galerias'
    );
    console.log('this.data :>> ', this.data);
    if (galleryStyle && galleryStyle.selected === 'expandGalleryImage') {
      this.uiSv.showModal(
        OpenCarruselGalleriesComponent,
        {
          images: this.galleries,
          selected: gallery,
          typeImg: 'gallerie',
        },
        'carrusel-galleries'
      );
    } else if (this.data?.type === 'featuredGalleriesSelected') {
      this.emitGalleyId.emit(gallery.id);
    } else {
      this.navCtrl.navigateForward(`gallery/${gallery.id}`);
    }
  }

  slideTo(type) {
    type === 'next'
      ? this.slideGallery.slideNext(400)
      : this.slideGallery.slidePrev(400);
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(async () => {
        this.reachedEnd = await this.slideSv.isEnd(this.slideGallery);
      });
    }
  }

  async changedSlide(ev) {
    this.reachedEnd = ev.el.dom7ElementDataStorage.swiper.isEnd;
    if (!this.reachedEnd || this.reachedEnd) {
      this.isStart = ev.el.dom7ElementDataStorage.swiper.isBeginning;
    }
  }

  showGaleries() {
    this.navCtrl.navigateForward('magazine', {
      queryParams: {
        id: this.catalogueId,
        categoryId: this.categoryId,
      },
    });
  }
}
